import { render } from "./ModalAmlHold.vue?vue&type=template&id=4eee3cd4&scoped=true"
import script from "./ModalAmlHold.vue?vue&type=script&lang=js"
export * from "./ModalAmlHold.vue?vue&type=script&lang=js"

import "./ModalAmlHold.vue?vue&type=style&index=0&id=4eee3cd4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eee3cd4"]])

export default __exports__